import stylesheet_17 from '../stylesheets/17.js';
import stylesheet_16 from '../stylesheets/16.js';
import stylesheet_18 from '../stylesheets/18.js';

export const index = 9;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/services/accelerated-training/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/9.b7790879.js","_app/immutable/chunks/scheduler.2887eafe.js","_app/immutable/chunks/index.387b3ba3.js","_app/immutable/chunks/Wrapper.6637e6f2.js","_app/immutable/chunks/Hero.8f39fbbd.js","_app/immutable/chunks/each.77017db3.js","_app/immutable/chunks/ContentCard.cca2716c.js"];
export const stylesheets = ["_app/immutable/assets/Wrapper.54de1bd5.css","_app/immutable/assets/Hero.71a30b75.css","_app/immutable/assets/ContentCard.b5a2f49f.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/Wrapper.54de1bd5.css": stylesheet_17,
	"_app/immutable/assets/Hero.71a30b75.css": stylesheet_16,
	"_app/immutable/assets/ContentCard.b5a2f49f.css": stylesheet_18
});
